import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import AppLayout from '../../../component/appLayout';
import {
  Group,
  HeaderBlock,
  Heading,
  Icon,
  Title,
  RightHeading,
  Icons,
  Content,
  LeftContent,
  MainDiv,
  InvoiceTable,
  TopInvoice,
  InvoiceRight,
  InvoiceMiddle,
  InvoiceLeft,
  Details,
  InputId,
  Text,
  Info,
  FromAddress,
  From,
  Address,
  InvoiceTitle,
  GroupHeader,
  RightHeader,
  Quantity,
  Amount,
  Label,
  Price,
  Row,
  RightRow,
  LeftRow,
  InfoRate,
  Total,
  Subtotal,
  Name,
  TotalAmount,
  TotalContent,
  TotalRate,
  NoteDiv,
  RecordDetail,
  AmountRate,
  QuantityRate,
  Info1,
  InvoiceResponsive,
  InvoiceCard,
  TopContentTotal,
  TableDataResponsive,
  InvoiceTableTitle,
  HeaderLeft,
  RecordDropdown,
  OuterDiv,
  LeftContentWrapper,
  DottedDesign
} from './styles';
import {
  deleteInvoice,
  getInvoiceActivityDetailData,
  getInvoiceViewData,
  updateRecordPayment
} from '../../../services/invoiceService';
import { useHistory, useParams } from 'react-router-dom';
import { currencySymbols, invoiceDetailMoreMenu } from '../../../global/row';
import dayjs, { Dayjs } from 'dayjs';
import {
  CurrencyInterfase,
  duplicateInputInvoiceInterface,
  InvoiceActivityDetailsInterface,
  projectIdInterface
} from '../../../interfaces/InvoiceInterface';
import DeleteModal from '../../../component/modals/deleteModal';
import { currencyWithDecimal, getInvoiceIcon, isEmpty } from '../../../helpers/common';
import { getCustomerProjectDetail } from '../../../services/customerServices';
import { ROUTES } from '../../../routes/urls';
import Button from '../../../component/button';
import Modal from '../../../component/modals/modal';
import SendInvoiceModal from '../../../component/modals/sendInvoiceModal';
import UserPreferenceSingleton from '../../../helpers/userPreferenceSingleton';
import InvoiceDetailLoading from '../../../component/loading/invoiceDetailsLoading';
import {
  BUTTON_TYPE,
  CUSTOMER_MEMBER_ROLE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  ICON_SIZE,
  INVOICE_STATUS_TYPE,
  MENU_OPTIONS
} from '../../../global/constants';
import { getInvoicingSettingsData } from '../../../services/settingServices';
import { captureException } from '../../../services/logService';
import { REACT_APP_TEAMCAMP_APIURL } from '../../../global/environment';
import { trackAnalyticActivity } from '../../../services/analyticsService';
import InvoiceActivity from './invoiceactivity';
import { INVOICE_ANALYTICS } from '../../../global/analyticsConstants';
import { useMobileDevice } from '../../../global/useMobile';
import { Dropdown, DropdownItem } from '../../../component/dropdown';
import DatePicker from '../../../component/dateTime';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import ResponsiveHeader from '../../../component/responsiveHeader';
import BottomSubNavigation from '../../../component/bottomNavigation/subNavigation';
import BottomNavigationItem from '../../../component/bottomNavigation/subNavigation/bottomNavigationItem';
import IconButton from '../../../component/button/iconButton';
import Input from '../../../component/input';
import TextArea from '../../../component/input/textArea';
import Image from '../../../component/image';

const InvoicesDetails: React.FC = () => {
  //Ref
  const recordPaymentDropdownRef = useRef<{ closeDropdown: () => void } | null>(null);

  //States
  const [date, setDate] = useState<Dayjs | null>(null); // Type date as Dayjs or null
  const [amount, setAmount] = useState<string>();
  const [notes, setNotes] = useState<string>();
  const [deleteModelOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [deleteInvoiceLoading, setDeleteInvoiceLoading] = useState(false);
  const [invoiceModelOpen, setInvoiceModelOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({ id: '' });
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [invoiceActivityDetail, setInvoiceActivityDetail] = useState<InvoiceActivityDetailsInterface[]>([]);

  // mobx store variable
  const { currentUser, appStore, workspaceStore, settingStore, invoiceStore } = rootStore;
  const { invoiceViewData } = invoiceStore;
  const { themeMode } = appStore || {};
  const { currentWorkspace: workspace } = workspaceStore;
  const { id: workspace_id, customerRole, isOwner, isAdmin } = workspace || {};
  const { invoiceSetting } = settingStore;

  //Other variable
  const isMobile = useMobileDevice();
  const params: { id: string } = useParams();
  const history = useHistory();

  // load initial data
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace_id)) {
        setLoadingData(true);
        const response = await Promise.all([
          getInvoiceViewData(params?.id),
          getInvoiceActivityDetailData(params?.id, workspace),
          getInvoicingSettingsData(workspace_id)
        ]);
        setInvoiceActivityDetail(response[1]);
        const result = response?.[0];
        const currency: CurrencyInterfase | undefined = currencySymbols.find((x) => x.code === result?.currency);
        if (result && currency) {
          setCurrencySymbol(currency?.symbol);
        }
      }
    } catch (error) {
      captureException(error);
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }, [params?.id, workspace, workspace_id]);

  useEffect(() => {
    trackAnalyticActivity(INVOICE_ANALYTICS.VIEW_DETAIL);
    loadData();
    return () => {
      rootStore.invoiceStore.setInvoiceViewData({
        companyId: '',
        currency: '',
        customer: {
          phone: '',
          lastName: '',
          id: '',
          firstName: '',
          companyName: '',
          email: '',
          companyId: '',
          address: '',
          status: undefined,
          projectId: ''
        },
        date: '',
        discount: 0,
        dueAmount: 0,
        dueDate: '',
        dueDays: 0,
        id: '',
        items: [],
        number: '',
        status: 0,
        statusText: '',
        tax: [],
        totalAmount: 0,
        totalDiscount: 0,
        totalTax: 0,
        totalTax2: 0,
        subTotal: 0
      });
      setInvoiceActivityDetail([]);
    };
  }, [loadData]);

  // for update date
  const onChange = useCallback((date: dayjs.Dayjs | null) => {
    setDate(date);
  }, []);

  // record payment
  const recordPayment = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        if (isEmpty(amount) || Number(amount) <= 0) {
          rootStore.alertNotificationStore.setErrorMessage('Amount must be greater then 0');
          return;
        }
        if (Number(amount) > invoiceViewData?.dueAmount) {
          rootStore.alertNotificationStore.setErrorMessage(
            'Please enter valid amount. Amount should be less than due amount.'
          );
          return;
        }
        const payload = {
          date: date?.format('YYYY-MM-DD'),
          amount: Number(amount),
          notes: notes || ''
        };
        if (isEmpty(date)) {
          return rootStore.alertNotificationStore.setErrorMessage('Please select date');
        }
        const result = await updateRecordPayment(params?.id, payload);
        if (result) {
          trackAnalyticActivity(INVOICE_ANALYTICS.PAYMENT_RECORDED);
          setDate(null);
          setAmount('');
          setNotes('');
          recordPaymentDropdownRef.current?.closeDropdown();
          loadData();
        }
      } catch (error) {
        captureException(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [params?.id, amount, notes, date, loadData, invoiceViewData]
  );

  // open delete model
  const openDeleteModel = useCallback(() => {
    setDeleteModalOpen(true);
  }, []);

  // close delete model
  const closeDeleteModel = useCallback(() => {
    setDeleteModalOpen(false);
    setSelectedItem({ id: '' });
  }, []);

  // open invoice model
  const openInvoiceModel = useCallback(() => {
    setInvoiceModelOpen(true);
  }, []);

  // close invoice model
  const closeInvoiceModel = useCallback(() => {
    setInvoiceModelOpen(false);
  }, []);

  // for delete invoice
  const onClickDeleteInvoice = useCallback(async () => {
    try {
      setDeleteInvoiceLoading(true);
      const result = await deleteInvoice(params?.id);
      if (result) {
        setDeleteModalOpen(false);
        trackAnalyticActivity(INVOICE_ANALYTICS.DELETED);
        rootStore.alertNotificationStore.setSuccessMessage('Invoice deleted successfully!');
        history.push(ROUTES.INVOICES);
      }
    } catch (error) {
      captureException(error);
    } finally {
      setDeleteInvoiceLoading(false);
    }
  }, [params?.id, history]);

  // for invoice edit
  const onInvoiceEdit = useCallback(async () => {
    try {
      rootStore.invoiceStore.setInvoiceDetail(invoiceViewData);
      const response = await Promise.all([getInvoiceViewData(invoiceViewData?.id)]);
      if (invoiceViewData?.statusText === 'DRAFT') {
        trackAnalyticActivity(INVOICE_ANALYTICS.VIEW_DRAFT);
      }
      rootStore.invoiceStore.setInvoiceDetail(response[0]);
      history.push(
        `${ROUTES.EDIT_INVOICES.replace(':invoice_id', invoiceViewData?.id)}?customer=${invoiceViewData?.customer?.id}`
      );
    } catch (error) {
      captureException(error);
    }
  }, [invoiceViewData, history]);

  // redirect to web invoice
  const onclickWebInvoice = useCallback(() => {
    trackAnalyticActivity(INVOICE_ANALYTICS.PUBLIC_BUTTON_CLICKED);
    const newTab = window.open(`https://invoice.teamcamp.app/${params?.id}`, '_blank');
    if (newTab) {
      newTab.focus();
    } else {
      alert('Please allow pop-ups for this site to open in a new tab.');
    }
  }, [params?.id]);

  // generate invoice pdf
  const generateInvoicePdf = useCallback(async (invoiceId: string, status: boolean) => {
    try {
      if (isEmpty(invoiceId)) return;
      const url = `${REACT_APP_TEAMCAMP_APIURL}/invoice/generateInvoicePdf/${invoiceId}?download=${status}`;
      if (status === true) {
        trackAnalyticActivity(INVOICE_ANALYTICS.PDF_BUTTON_CLICKED);
      } else {
        trackAnalyticActivity(INVOICE_ANALYTICS.PRINT_BUTTON_CLICKED);
      }
      window.open(url, '_blank');
    } catch (error) {
      captureException(error);
    }
  }, []);

  // for make duplicate invoice
  const onDuplicateInvoice = useCallback(async () => {
    try {
      if (!workspace_id) return;
      const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
      const projectResult = await getCustomerProjectDetail(workspace_id, invoiceViewData?.customer?.id);
      const updatedItem = invoiceViewData?.items?.map((item) => {
        if (!isEmpty(item?.projectId)) {
          const project = projectResult?.find((ele: { id: projectIdInterface }) => ele?.id === item?.projectId);
          return { ...item, projectId: project };
        } else {
          return item;
        }
      });
      const invoiceData: duplicateInputInvoiceInterface = {
        ...invoiceViewData,
        date: new Date().toISOString(),
        userId: userDetails?.id,
        customerId: invoiceViewData?.customer?.id,
        emails: [],
        items: updatedItem,
        isSendMeCopy: false,
        dueDate: invoiceViewData?.dueDays
          ? new Date(new Date().setDate(new Date().getDate() + invoiceViewData.dueDays)).toISOString()
          : '',
        dueDays: invoiceViewData?.dueDays?.toString()
      };
      const fieldsToDelete: (keyof duplicateInputInvoiceInterface)[] = [
        'id',
        'status',
        'paidAmount',
        'statusText',
        'number',
        'invoicePayment',
        'customer',
        'dueAmount'
      ];
      fieldsToDelete.forEach((field) => delete invoiceData?.[field]);
      rootStore.invoiceStore.setInvoiceDetail(invoiceData);
      history.push(`${ROUTES.ADD_NEW_INVOICES_2}?customer=${invoiceViewData?.customer?.id}`);
    } catch (error) {
      captureException(error);
    }
  }, [workspace_id, invoiceViewData, history]);

  // handle dropdown click
  const handleDropdownClick = useCallback(
    (key: number | string) => {
      key = Number(key);
      if (key === MENU_OPTIONS.EDIT) {
        onInvoiceEdit();
      } else if (key === MENU_OPTIONS.DELETE) {
        openDeleteModel();
      } else if (key === MENU_OPTIONS.DUPLICATE) {
        onDuplicateInvoice();
      }
    },
    [onDuplicateInvoice, onInvoiceEdit, openDeleteModel]
  );

  // render invoice data
  const renderInvoiceData = useMemo(() => {
    return invoiceViewData?.items?.map((itemData) => {
      const ref = currencySymbols.find((x) => x.code === invoiceViewData?.currency);
      const symbol = ref?.symbol;
      return (
        <Row key={itemData?.id}>
          <LeftRow>
            <Info1>{itemData?.desc}</Info1>
          </LeftRow>
          <RightRow>
            <TableDataResponsive>
              <InvoiceTableTitle>quantity</InvoiceTableTitle>
              <QuantityRate>{itemData?.qty}</QuantityRate>
            </TableDataResponsive>
            <TableDataResponsive>
              <InvoiceTableTitle>unit price</InvoiceTableTitle>
              <InfoRate>
                {symbol}
                {currencyWithDecimal(itemData?.unitPrice)}
              </InfoRate>
            </TableDataResponsive>
            <TableDataResponsive isLastData>
              <InvoiceTableTitle>amount</InvoiceTableTitle>
              <AmountRate>
                {symbol}
                {currencyWithDecimal(itemData?.amount)}
              </AmountRate>
            </TableDataResponsive>
          </RightRow>
        </Row>
      );
    });
  }, [invoiceViewData?.currency, invoiceViewData?.items]);

  const renderMoreMenuItems = useMemo(() => {
    return invoiceDetailMoreMenu.map((item) => (
      <DropdownItem
        key={item.key}
        label={item.label}
        onClick={() => handleDropdownClick(item.key)}
        tone={item.label === 'Delete' ? 'critical' : 'primary'}
      />
    ));
  }, [handleDropdownClick]);

  const renderRecordDropdown = (
    <Dropdown
      modalTitle='Record Payment'
      isMinWidth={268}
      isRemoveMaxHeight={true}
      isDatePickerOpen={true}
      ref={recordPaymentDropdownRef}
      content={
        !isMobile ? (
          <Button size='small' title='Record Payment' buttonType='button' variant={BUTTON_TYPE.SECONDARY} />
        ) : (
          <BottomNavigationItem iconName='record-invoice-icon' />
        )
      }
      trigger='click'>
      <form onSubmit={recordPayment}>
        <RecordDropdown role='button' onClick={(e) => e.stopPropagation()}>
          <RecordDetail>
            <Label>Payment Date</Label>
            <DatePicker
              onChange={onChange}
              label='Select Date'
              value={date?.toDate() || null}
              inputFormat='DD/MM/YYYY'
            />
          </RecordDetail>
          <Input
            label='Amount'
            placeHolder='2600.00'
            type='number'
            step='any'
            value={amount}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAmount(e.target.value)}
          />
          <TextArea
            height={'58px'}
            label='Notes'
            value={notes || ''}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setNotes(e.target.value)}
          />
          <Button title='Record Payment' variant={BUTTON_TYPE.PRIMARY} buttonType='submit' disabled={loading} />
        </RecordDropdown>
      </form>
    </Dropdown>
  );

  const renderMoreMenu = useCallback(() => {
    return (
      customerRole !== CUSTOMER_MEMBER_ROLE.FULL_ACCESS &&
      (isAdmin || isOwner) && (
        <Dropdown
          modalTitle='Manage Invoice'
          activeClassName='active'
          content={
            <IconButton
              iconName='three-dots-horizontal-icon'
              size={isMobile ? ICON_BUTTON_SIZE.LARGE : ICON_BUTTON_SIZE.MEDIUM}
              variant={ICON_BUTTON_TYPE.TERTIARY}
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            />
          }
          trigger='click'>
          {renderMoreMenuItems}
        </Dropdown>
      )
    );
  }, [customerRole, isAdmin, isMobile, isOpen, isOwner, renderMoreMenuItems]);

  // renders invoice status image
  const renderInvoiceStatusImage = useMemo(() => {
    return (
      <InvoiceMiddle>
        <Image
          src={getInvoiceIcon(invoiceViewData?.status)}
          alt='PaidSymbol'
          width={isMobile ? 50 : 100}
          height={isMobile ? 50 : 100}
        />
      </InvoiceMiddle>
    );
  }, [invoiceViewData?.status, isMobile]);

  // renders invoice logo
  const renderInvoiceLogo = useMemo(() => {
    return (
      <Image
        imageUrl={!isEmpty(invoiceSetting?.invoiceLogo) ? invoiceSetting?.invoiceLogo : 'invoicing_empty_profile'}
        width={40}
        height={40}
        className={!isEmpty(invoiceSetting?.invoiceLogo) ? 'invoice-logo-image' : ''}
      />
    );
  }, [invoiceSetting?.invoiceLogo]);

  return (
    <>
      <AppLayout isOverflowHidden={!isMobile ? true : false}>
        <OuterDiv className='desktop-content'>
          {/* responsive header */}
          {isMobile && (
            <ResponsiveHeader
              subTitle={invoiceViewData?.number}
              title={invoiceViewData?.customer?.companyName}
              leftElement={renderMoreMenu()}
            />
          )}
          <Group>
            {/* desktop Header */}
            {!isMobile && (
              <HeaderBlock>
                <HeaderLeft>
                  <Heading>
                    <Icon>
                      <SVGIcon
                        name='invoice-icon'
                        width={ICON_SIZE.LG}
                        height={ICON_SIZE.LG}
                        viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                        fill='var(--brand-primary)'
                      />
                    </Icon>
                    <Title>{invoiceViewData?.number}</Title>
                  </Heading>
                </HeaderLeft>
                <RightHeading>
                  <Icons>
                    <IconButton
                      iconName='globe-icon'
                      size={ICON_BUTTON_SIZE.MEDIUM}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      onClick={onclickWebInvoice}
                    />
                    <IconButton
                      iconName='updated-file-icon'
                      size={ICON_BUTTON_SIZE.MEDIUM}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      onClick={() => generateInvoicePdf(invoiceViewData?.id, true)}
                    />
                    <IconButton
                      iconName='invoice-details-header-print-icon'
                      size={ICON_BUTTON_SIZE.MEDIUM}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      onClick={() => generateInvoicePdf(invoiceViewData?.id, false)}
                    />
                  </Icons>
                  {invoiceViewData?.status !== INVOICE_STATUS_TYPE.PAID &&
                    customerRole !== CUSTOMER_MEMBER_ROLE.FULL_ACCESS &&
                    (isAdmin || isOwner) &&
                    renderRecordDropdown}
                  {customerRole !== CUSTOMER_MEMBER_ROLE.FULL_ACCESS && (isAdmin || isOwner) && (
                    <Button
                      size='small'
                      title='Send Invoice'
                      variant={BUTTON_TYPE.PRIMARY}
                      buttonType='button'
                      onClick={openInvoiceModel}
                    />
                  )}
                  {renderMoreMenu()}
                </RightHeading>
              </HeaderBlock>
            )}
            {/* Invoice  */}
            {!loadingData && (
              <Content>
                <LeftContentWrapper className='desktop-invoice-detail-content'>
                  <LeftContent>
                    <DottedDesign isDark={themeMode.theme} />
                    <MainDiv>
                      <TopInvoice>
                        <InvoiceLeft>
                          {!isMobile && renderInvoiceLogo}
                          <Details>
                            <InputId>
                              <h1>Invoice ID</h1>
                              <p>{invoiceViewData?.number}</p>
                            </InputId>
                            <InputId>
                              <h1>Issue Date</h1>
                              <p>{dayjs(invoiceViewData?.date).format(currentUser?.dateFormat)} </p>
                            </InputId>
                            {!isEmpty(invoiceViewData?.dueDate) && (
                              <InputId>
                                <h1>Due Date</h1>
                                <p>{dayjs(invoiceViewData?.dueDate).format(currentUser?.dateFormat)}</p>
                              </InputId>
                            )}
                          </Details>
                        </InvoiceLeft>
                        {!isMobile && renderInvoiceStatusImage}
                        <InvoiceRight>
                          <InvoiceResponsive>
                            {/* render invoice logo */}
                            {isMobile && renderInvoiceLogo}
                            {/* render invoice status image */}
                            {isMobile && renderInvoiceStatusImage}
                            <InvoiceTitle>INVOICE</InvoiceTitle>
                          </InvoiceResponsive>
                          <Address>
                            <From>
                              <Text>From :</Text>
                              <FromAddress>
                                <Info>{!isEmpty(invoiceSetting?.name) ? invoiceSetting?.name : workspace?.name}</Info>
                                {!isEmpty(invoiceSetting?.address) && (
                                  <Text
                                    dangerouslySetInnerHTML={{
                                      __html: (invoiceSetting?.address ?? '').replace(/\n/g, '<br/>')
                                    }}></Text>
                                )}
                              </FromAddress>
                            </From>
                            <From>
                              <Text>Invoice For :</Text>
                              <FromAddress>
                                <Info>{invoiceViewData?.customer?.companyName}</Info>
                                <Text>{invoiceViewData?.customer?.address}</Text>
                              </FromAddress>
                            </From>
                          </Address>
                        </InvoiceRight>
                      </TopInvoice>
                      <InvoiceTable>
                        {!isMobile && (
                          <GroupHeader>
                            <Label>DESCRIPTION</Label>
                            <RightHeader>
                              <Quantity>Qty</Quantity>
                              <Price>Unit Price</Price>
                              <Amount>Amount</Amount>
                            </RightHeader>
                          </GroupHeader>
                        )}
                        <InvoiceCard>{renderInvoiceData}</InvoiceCard>
                        <Total isHideBottomBorder={isEmpty(invoiceViewData?.notes)}>
                          <TopContentTotal>
                            <Subtotal>
                              <Name>Subtotal</Name>
                              <TotalRate>
                                {currencySymbol}

                                {currencyWithDecimal(invoiceViewData?.subTotal)}
                              </TotalRate>
                            </Subtotal>
                            {invoiceViewData?.discount > 0 && (
                              <Subtotal>
                                <Name>Discount ({invoiceViewData?.discount}%)</Name>
                                <TotalRate>
                                  -{currencySymbol}
                                  {currencyWithDecimal(invoiceViewData?.totalDiscount)}
                                </TotalRate>
                              </Subtotal>
                            )}
                            {!isEmpty(invoiceViewData?.tax?.[0]) && invoiceViewData?.tax?.[0]?.value > 0 && (
                              <Subtotal>
                                <Name>
                                  {invoiceViewData?.tax?.[0]?.name || 'Tax'} ({invoiceViewData?.tax?.[0]?.value || 0}%)
                                </Name>
                                <TotalRate>
                                  {currencySymbol}
                                  {currencyWithDecimal(invoiceViewData?.totalTax)}
                                </TotalRate>
                              </Subtotal>
                            )}
                            {!isEmpty(invoiceViewData?.tax?.[1]) && invoiceViewData?.tax?.[1]?.value > 0 && (
                              <Subtotal>
                                <Name>
                                  {invoiceViewData?.tax?.[1]?.name || 'Tax 2'} ({invoiceViewData?.tax?.[1]?.value || 0}
                                  %)
                                </Name>
                                <TotalRate>
                                  {currencySymbol}
                                  {currencyWithDecimal(invoiceViewData?.totalTax2)}
                                </TotalRate>
                              </Subtotal>
                            )}
                          </TopContentTotal>
                          <TotalAmount>
                            <Name>Amount Due:</Name>
                            <TotalContent>
                              {currencySymbol}
                              {currencyWithDecimal(invoiceViewData?.dueAmount)}
                            </TotalContent>
                          </TotalAmount>
                        </Total>
                        {!isEmpty(invoiceViewData?.notes) && (
                          <NoteDiv>
                            <h2>Note</h2>
                            <p>{invoiceViewData?.notes}</p>
                          </NoteDiv>
                        )}
                      </InvoiceTable>
                    </MainDiv>
                    <DottedDesign isDark={themeMode.theme} />
                  </LeftContent>
                </LeftContentWrapper>

                <InvoiceActivity
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  loadData={loadData}
                  deleteInvoiceLoading={deleteInvoiceLoading}
                  setDeleteInvoiceLoading={setDeleteInvoiceLoading}
                  invoiceActivityDetail={invoiceActivityDetail}
                />
              </Content>
            )}
            {loadingData && <InvoiceDetailLoading />}
          </Group>
        </OuterDiv>
      </AppLayout>
      <Modal open={deleteModelOpen} onClose={closeDeleteModel} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeDeleteModel}
          onOk={onClickDeleteInvoice}
          loading={deleteInvoiceLoading}
          modalTitle='Delete Invoice?'
          description='Are you sure to want to delete this invoice?'
        />
      </Modal>
      <Modal open={invoiceModelOpen} onClose={closeInvoiceModel} maxWidth={'674px'} isResponsiveMaxWidth={true}>
        <SendInvoiceModal invoiceId={params?.id} onClose={closeInvoiceModel} workspaceId={workspace_id || ''} />
      </Modal>
      <BottomSubNavigation
        disableKeyboardHide
        rightElement={
          <>
            {renderRecordDropdown}
            <BottomNavigationItem iconName='send-icon' onClick={openInvoiceModel} />
          </>
        }
      />
    </>
  );
};
export default observer(InvoicesDetails);
